
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import './App.css';


// importación de componentes
// import AuthService from './services/AuthService.js';
import React, { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import Loading from './components/Loading.jsx';

// importaciones dinamicas con lazy
const Empresas = lazy(() => import('./modules/empresas/Empresas.jsx'));
const Usuarios = lazy(() => import('./modules/usuarios/Usuarios.jsx'));
const Empleados = lazy(() => import('./modules/empleados/Empleados.jsx'));
const Externos = lazy(() => import('./modules/externos/Externos.jsx'));
const Vehiculos = lazy(() => import('./modules/vehiculos/Vehiculos.jsx'));
const Credenciales = lazy(() => import('./modules/credenciales/Credenciales.jsx'));
const Accesos = lazy(() => import('./modules/accesos/Accesos.jsx'));


const App = () => {

  // const [count,setCount] = useState(0); 

  return (
    <React.Fragment>
      <Suspense fallback={<Loading />}>
      <Routes>
        <Route path="/empresas" element={<Empresas />} />
        <Route path="/usuarios" element={<Usuarios />} />
        <Route path="/empleados" element={<Empleados />} />
        <Route path="/externos" element={<Externos />} />
        <Route path="/vehiculos" element={<Vehiculos />} />
        <Route path="/cindefinido" element={<Credenciales tipo={1} />} />
        <Route path="/cpfijo" element={<Credenciales tipo={2} />} />
        <Route path="/cproveedor" element={<Credenciales tipo={3} />} />
        <Route path="/ccliente" element={<Credenciales tipo={4} />} />
        <Route path="/cvisita" element={<Credenciales tipo={5} />} />
        <Route path="/cdescarte" element={<Credenciales tipo={6} />} />
        <Route path="/cconsumo" element={<Credenciales tipo={7} />} />
        <Route path="/cexternos" element={<Credenciales tipo={9999} />} />
        <Route path="/accesos" element={<Accesos />} />
      </Routes>
      </Suspense>
    </React.Fragment>


  );
}

export default App;
